import { downgradeComponent } from '@angular/upgrade/static';
import { EmailSubscriptionComponent } from '@mode/shared/schedules/feature-email-subscription';
import { ActionBarComponent, NamedScheduleHeaderComponent } from '@mode/shared/schedules/feature-schedule-editor';
import {
  CadenceConfigComponent,
  DayOfMonthSelectorComponent,
  DeliveryComponent,
  InfoBannerComponent,
  MinuteScheduleConfigComponent,
  MonthlyScheduleConfigComponent,
  ParametersComponent,
  ScheduleListItemComponent,
  TimeWithTimeZoneSelectorComponent,
  WeekdayScheduleSelectorComponent,
  WeeklyScheduleConfigComponent,
} from '@mode/shared/schedules/ui';
import * as angular from 'angular';

export const DowngradedSharedSchedulesUIModule = angular
  .module('downgraded-shared-schedules-ui', [])
  .directive('modeEmailSubscription', downgradeComponent({ component: EmailSubscriptionComponent }))
  .directive('modeDayOfMonthSelector', downgradeComponent({ component: DayOfMonthSelectorComponent }))
  .directive('modeMinuteScheduleConfig', downgradeComponent({ component: MinuteScheduleConfigComponent }))
  .directive('modeMonthlyScheduleConfig', downgradeComponent({ component: MonthlyScheduleConfigComponent }))
  .directive('modeWeeklyScheduleConfig', downgradeComponent({ component: WeeklyScheduleConfigComponent }))
  .directive('modeDelivery', downgradeComponent({ component: DeliveryComponent }))
  .directive('modeWeekdayScheduleSelector', downgradeComponent({ component: WeekdayScheduleSelectorComponent }))
  .directive('modeCadenceConfig', downgradeComponent({ component: CadenceConfigComponent }))
  .directive('modeScheduleListItem', downgradeComponent({ component: ScheduleListItemComponent }))
  .directive('modeTimeWithTimeZoneSelector', downgradeComponent({ component: TimeWithTimeZoneSelectorComponent }))
  .directive('modeParameters', downgradeComponent({ component: ParametersComponent }))
  .directive('modeInfoBanner', downgradeComponent({ component: InfoBannerComponent }))
  .directive('modeNamedScheduleHeader', downgradeComponent({ component: NamedScheduleHeaderComponent }))
  .directive('modeScheduleEditorActionBar', downgradeComponent({ component: ActionBarComponent })).name;
